import React from 'react';
import Slider from 'react-slick';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Img from 'gatsby-image'

// Custom Previous Arrow component
const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div onClick={onClick} className="custom-arrow custom-prev-arrow">
      <button className="button is-outlined is-secondary">
          <ChevronLeft className='is-clickable' color="#000" size={24} />
      </button>
    </div>
  );
};

// Custom Next Arrow component
const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <div onClick={onClick} className="custom-arrow custom-next-arrow">
       <button className="button is-outlined is-secondary">
          <ChevronRight className='is-clickable' color="#000" size={24} />
        </button>
    </div>
  );
};

const SimpleSlider = ( {images} ) => {
  console.log(images);
  
  var settings = {
    dots: false,
    infinite: true,
    fade: true,
    lazyLoad: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <Img fluid={image} alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default SimpleSlider;
